<template>
    <section class="breadcrumbs-custom">
        <div class="parallax-container">
            <div class="material-parallax parallax"><img src="/assets/images/banner_section_2.png" alt="breadcrumbs" ></div>
            <div class="breadcrumbs-custom-body parallax-content context-dark">
                <div class="container">
                    <h2 class="breadcrumbs-custom-title">About Us</h2>
                </div>
            </div>
        </div>
        <div class="breadcrumbs-custom-footer">
            <div class="container">
                <ul class="breadcrumbs-custom-path">
                    <li><router-link to="/" class="rd-nav-link">Home</router-link></li>
                    <li class="active">About Us</li>
                </ul>
            </div>
        </div>
    </section>

    <section class="section section-xl bg-image-1">
        <div class="container">
            <h2 class="wow fadeScale">Cake Gurus Story</h2>
            <div class="row row-lg row-30 justify-content-center">
                <div class="col-sm-8 col-md-6 wow fadeInLeft">
                    <article class="post post-nikki post-nikki-2">
                        <div class="post-nikki-figure"><img src="/assets/images/Logo-High-Resolution-WHITE-BG.jpg" alt="" width="570" height="461"/></div>
                        <!-- <div class="post-nikki-body">
                            <div>
                                <div class="post-nikki-time">
                                    <time datetime="2023-09-08">August 9, 2023</time>
                                </div>
                                <div class="post-nikki-title"><a href="#">How to Pipe a Fluffy Frosting Border on a Cake</a></div>
                            </div>
                        </div> -->
                    </article>
                </div>
                <div class="col-md-6">
                    <article class="post post-nikki wow fadeInRight">
                        <div class="unit unit-spacing-lg flex-column flex-md-row align-items-center">
                            <div class="unit-body">
                                <!-- <div class="post-nikki-time">
                                    <time datetime="2023-09-08">August 9, 2023</time>
                                </div> -->
                                <div class="post-nikki-title1">
                                    <p>Much like a new seed being planted and then watered into growth, CakeGurus was initially just an idea which was derived out of a passion for a healthy lifestyle. Every bit of this idea involved immense hard work to finally see it flying. We are overjoyed to present to you the freshly baked Cakes, you cannot put your eyes and tongue off from.</p>
                                    <p>At the outset we realized, there was far less accessibility to Eggless and Vegan friendly Cakes in the marketplace. With the healthy lifestyle being in vogue, this seemed like a golden opportunity for us to not only fulfill this vacuum but also be the solitary seller of these Cakes. Sweet yet healthy!</p>
                                    <p>Every Cake is a work of art, wonderfully baked and nicely whipped. CakeGurus use the best quality ingredients to prepare the most flavourful and mouth watering Cakes while keeping your choices at priority. Be it a ravishing wedding ceremony or a birthday celebration, we are readily available to offer Eggless and Vegan Cakes with gluten free options as well.</p>
                                    <p>CakeGurus can be a Pandora Box for all the creativity you are looking for. We can bake the Cake the way you actually want. Any customised demand will be honoured and we promise you will be utterly satisfied.</p>
            
                                </div>
                            </div>
                        </div>
                    </article>
                </div>
                <div class="col-md-12">
                    <article class="post post-nikki wow fadeInRight">
                        <div class="unit unit-spacing-lg flex-column flex-md-row align-items-center">
                            <div class="unit-body">
                                <div class="post-nikki-title1">
                                    <p>We heartily welcome you to join us in our flavourful and healthy journey full of love. Longingly hope to see you all at CakeGurus for your next delightful yummy Cake.</p>                
                                </div>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-xl bg-default">
        <div class="container">
            <h2 class="wow fadeScale">About us</h2>
            <div class="row row-30 row-lg justify-content-center">
            <div class="col-sm-8 col-md-7 col-lg-6 wow fadeInLeft"><img src="/assets/images/premium_cakes.png" alt="" width="570" height="511"/></div>
            <div class="col-md-10 col-lg-6 wow fadeInRight">
                <!-- Bootstrap tabs-->
                <div class="tabs-custom tabs-jean" id="tabs-1">
                <!-- Tab panes-->
                <div class="tab-content">
                    <div class="tab-pane fade show active" id="tabs-1-1">
                    <div class="box-info-creative">
                        <h4 class="box-info-creative-title"><a href="#">providing quality baked goods for all customers</a></h4>
                        <div class="box-info-creative-text">Our mission is to create a bakery that makes the best quality baked goods on site from scratch, and where both employees and customers would feel comfortable.</div>
                        <!-- <a class="link-classic box-info-creative-link" href="#">Read more</a> -->
                    </div>
                    </div>
                    <div class="tab-pane fade" id="tabs-1-2">
                    <div class="box-info-creative">
                        <h4 class="box-info-creative-title"><a href="#">Ensuring the Best Atmosphere for Everyone</a></h4>
                        <div class="box-info-creative-text">We see the most important part of our business in ensuring the happiness of our staff and the satisfaction of our clients by creating a welcoming and caring atmosphere.</div>
                        <!-- <a class="link-classic box-info-creative-link" href="#">Read more</a> -->
                    </div>
                    </div>
                    <div class="tab-pane fade" id="tabs-1-3">
                    <div class="box-info-creative">
                        <h4 class="box-info-creative-title"><a href="#">Serving only the freshest baked goods for you</a></h4>
                        <div class="box-info-creative-text">We aim to deliver the best baked goods for corporate events and individual celebrations, while also offering the best level of customer service in the United States.</div>
                        <!-- <a class="link-classic box-info-creative-link" href="#">Read more</a> -->
                    </div>
                    </div>
                </div>
                <!-- Nav tabs-->
                <div class="nav-tabs-wrap">
                    <ul class="nav nav-tabs">
                    <li class="nav-item" role="presentation"><a class="nav-link active" href="#tabs-1-1" data-bs-toggle="tab">Our mission</a></li>
                    <li class="nav-item" role="presentation"><a class="nav-link" href="#tabs-1-2" data-bs-toggle="tab">Our Values</a></li>
                    <li class="nav-item" role="presentation"><a class="nav-link" href="#tabs-1-3" data-bs-toggle="tab">Our goals</a></li>
                    </ul>
                </div>
                </div>
            </div>
            </div>
        </div>
    </section>

    <section class="section section-xl bg-image-1">
        <div class="container">
            <h2 class="pb-xl-0 wow fadeScale">Why choose us</h2>
            <div class="row row-xxl-2 row-30 row-md-40 row-lg-50 align-items-center">
            <div class="col-md-5 col-xl-4">
                <div class="row row-30 row-md-40 row-lg-50 bordered-2">
                <div class="col-sm-6 col-md-12">
                    <article class="box-icon-nancy box-icon-nancy-right text-center text-lg-end wow fadeInLeft">
                    <div class="unit unit-spacing-sm flex-column flex-lg-row-reverse">
                        <div class="unit-left">
                        <div class="double-icon">
                            <div class="box-icon-nancy-icon linearicons-cake"></div>
                            <div class="box-icon-nancy-svg">
                            <svg class="svg-bg" width="77.06" height="71.94" viewBox="0 0 77.06 71.94">
                                <path d="M1220.63,3358.07c8.86-19.66,32.66-7.87,38.1,13a39.053,39.053,0,0,1-27.91,47.63c-20.85,5.44-43.52-6.76-47.59-27.93C1179.83,3373.1,1210.55,3380.43,1220.63,3358.07Z" transform="translate(-1182.94 -3348.03)"></path>
                            </svg>
                            </div>
                        </div>
                        </div>
                        <div class="unit-body">
                        <h4 class="box-icon-nancy-title"><a href="#">Quality Products</a></h4>
                        <p class="box-icon-nancy-text">We guarantee the quality of all the  cakes we provide as they are baked using the freshest ingredients.</p>
                        </div>
                    </div>
                    </article>
                </div>
                <div class="col-sm-6 col-md-12">
                    <article class="box-icon-nancy box-icon-nancy-right text-center text-lg-end wow fadeInLeft" data-wow-delay=".1s">
                    <div class="unit unit-spacing-sm flex-column flex-lg-row-reverse">
                        <div class="unit-left">
                        <div class="double-icon">
                            <div class="box-icon-nancy-icon linearicons-truck"></div>
                            <div class="box-icon-nancy-svg">
                            <svg class="svg-bg" width="77.06" height="71.94" viewBox="0 0 77.06 71.94">
                                <path d="M1220.63,3358.07c8.86-19.66,32.66-7.87,38.1,13a39.053,39.053,0,0,1-27.91,47.63c-20.85,5.44-43.52-6.76-47.59-27.93C1179.83,3373.1,1210.55,3380.43,1220.63,3358.07Z" transform="translate(-1182.94 -3348.03)"></path>
                            </svg>
                            </div>
                        </div>
                        </div>
                        <div class="unit-body">
                        <h4 class="box-icon-nancy-title"><a href="#">Huge Range Of Flavours</a></h4>
                        <p class="box-icon-nancy-text">CakeGurus has a huge range of flavours to choose from. Go ahead and order Cake online to bring a massive smile on the face of your loved ones.</p>
                        </div>
                    </div>
                    </article>
                </div>
                </div>
            </div>
            <div class="col-md-2 col-xl-4 d-none d-md-block wow fadeScale"><img src="/assets/images/standard_cakes.png" alt="" width="377" height="212"/>
            </div>
            <div class="col-md-5 col-xl-4">
                <div class="row row-30 row-md-40 row-lg-50 bordered-2">
                <div class="col-sm-6 col-md-12">
                    <article class="box-icon-nancy box-icon-nancy-left text-center text-lg-start wow fadeInRigth">
                    <div class="unit unit-spacing-sm flex-column flex-lg-row">
                        <div class="unit-left">
                        <div class="double-icon">
                            <div class="box-icon-nancy-icon linearicons-lotus"></div>
                            <div class="box-icon-nancy-svg">
                            <svg class="svg-bg" width="77.06" height="71.94" viewBox="0 0 77.06 71.94">
                                <path d="M1220.63,3358.07c8.86-19.66,32.66-7.87,38.1,13a39.053,39.053,0,0,1-27.91,47.63c-20.85,5.44-43.52-6.76-47.59-27.93C1179.83,3373.1,1210.55,3380.43,1220.63,3358.07Z" transform="translate(-1182.94 -3348.03)"></path>
                            </svg>
                            </div>
                        </div>
                        </div>
                        <div class="unit-body">
                        <h4 class="box-icon-nancy-title"><a href="#">Customise Your Cake</a></h4>
                        <p class="box-icon-nancy-text">CakeGurus prides itself on being able to customise any Cake in accordance with your needs and we are certain that you will not be disappointed.</p>
                        </div>
                    </div>
                    </article>
                </div>
                <div class="col-sm-6 col-md-12">
                    <article class="box-icon-nancy box-icon-nancy-left text-center text-lg-start wow fadeInRight" data-wow-delay=".1s">
                    <div class="unit unit-spacing-sm flex-column flex-lg-row">
                        <div class="unit-left">
                        <div class="double-icon">
                            <div class="box-icon-nancy-icon linearicons-credit-card"></div>
                            <div class="box-icon-nancy-svg">
                            <svg class="svg-bg" width="77.06" height="71.94" viewBox="0 0 77.06 71.94">
                                <path d="M1220.63,3358.07c8.86-19.66,32.66-7.87,38.1,13a39.053,39.053,0,0,1-27.91,47.63c-20.85,5.44-43.52-6.76-47.59-27.93C1179.83,3373.1,1210.55,3380.43,1220.63,3358.07Z" transform="translate(-1182.94 -3348.03)"></path>
                            </svg>
                            </div>
                        </div>
                        </div>
                        <div class="unit-body">
                        <h4 class="box-icon-nancy-title"><a href="#">Online payment</a></h4>
                        <p class="box-icon-nancy-text">We accept all kinds of online payments including Visa, MasterCard, American Express credit cards.</p>
                        </div>
                    </div>
                    </article>
                </div>
                </div>
            </div>
            </div>
        </div>
    </section>

    <section class="section section-xl bg-default">
        <div class="container">
            <h2 class="wow fadeScale">Testimonials</h2>
            <div class="owl-carousel owl-style-11" data-items="1" data-sm-items="1" data-md-items="1" data-lg-items="2" data-xl-items="2" data-xxl-items="2" data-margin="30" data-dots="true" data-autoplay="false">
                <article class="quote-carly quote-carly-1" v-for="(testimonial, index) in testimonials" :key="index">
                    <div class="quote-carly-text">
                        <div class="q" v-html="testimonial.description"></div>
                    </div>
                    <div class="quote-carly-footer">
                        <div class="unit unit-spacing-sm flex-column flex-md-row align-items-center">
                            <!-- <div class="unit-left">
                                <div class="quote-carly-figure"><img src="/assets/images/user-10-62x62.jpg" alt="user" width="62" height="62"/></div>
                            </div> -->
                            <div class="unit-body">
                                <div class="quote-carly-author">{{ testimonial.name }}</div>
                                <!-- <div class="quote-carly-status">User</div> -->
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </section>
    
    <!-- <section class="section section-xxl bg-image-1">
        <div class="container">
            <h3 class="fw-regular">#2</h3>
            <div class="row row-30 justify-content-center">
            <div class="col-xl-9">
                <div class="slick-quote">
                <div class="slick-slider carousel-parent" id="carousel-parent-3" data-autoplay="true" data-swipe="true" data-items="1" data-child="#child-carousel-3" data-for="#child-carousel-3">
                    <div class="item" v-for="(testimonial, index) in testimonials" :key="index">
                        <div v-html="testimonial.description"></div>
                    </div>
                </div>

                <div class="slick-quote-nav">
                    <div class="slick-slider child-carousel" id="child-carousel-3" data-arrows="true" data-for="#carousel-parent-3" data-items="1" data-sm-items="1" data-md-items="3" data-lg-items="3" data-xl-items="3" data-xxl-items="3">
                    <div class="item" v-for="(testimonial, index) in testimonials" :key="index">
                        <div class="quote-minimal-figure"><img src="/assets/images/user-7-87x87.jpg" alt="" width="87" height="87"/>
                        </div>
                        <div class="quote-minimal-author">{{ testimonial.name }}</div>
                        <div class="quote-minimal-status">User</div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    </section> -->

    <section class="section section-xl bg-img-2">
        <div class="container">
            <div class="owl-carousel owl-style-2" data-items="2" data-sm-items="3" data-md-items="4" data-lg-items="5" data-margin="30" data-dots="true"><a class="clients-classic" href="#"><img src="/assets/images/clients-1-120x112.png" alt="" width="120" height="112"/></a><a class="clients-classic" href="#"><img src="/assets/images/clients-2-105x118.png" alt="" width="105" height="118"/></a><a class="clients-classic" href="#"><img src="/assets/images/clients-3-111x98.png" alt="" width="111" height="98"/></a><a class="clients-classic" href="#"><img src="/assets/images/clients-4-122x92.png" alt="" width="122" height="92"/></a><a class="clients-classic" href="#"><img src="/assets/images/clients-5-111x111.png" alt="" width="111" height="111"/></a></div>
        </div>
    </section>

</template>

<script setup>
import { onMounted } from 'vue'
import { useHead } from '@unhead/vue'
// import ImageComponent from "@/components/common/ImageComponent.vue";
import { useCommonStore } from "@/stores/commonStore";
import testimonials from '../json/testimonial.json'

const commonStore = useCommonStore();

useHead({
  title: 'CakeGurus',
  meta: [
    {
      name: 'description',
      content: 'About CakeGurus',
    },
  ],
})

onMounted(async () => {

    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
        // Replace it: remove and re-add
        existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)      

    commonStore.loaderVisible = false;
})


</script>
<style scoped>
.material-parallax img { 
  position: relative;
  filter: brightness(0.5);
}
</style>